"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettingRoundRadioButtonViewChoosed = exports.SettingRoundRadioButtonViewDefault = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var styles_1 = require("@material-ui/styles");
var Icon_1 = tslib_1.__importDefault(require("@material-ui/core/Icon"));
var MenuItem_1 = tslib_1.__importDefault(require("@material-ui/core/MenuItem"));
var useStyle = styles_1.makeStyles(function (theme) { return ({
    Wrap: {
        width: "100%",
    },
    radioIcon: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: 24,
        height: 24,
        marginRight: 8,
        color: theme.app.SettingRoundRadioButtonView.radioIcon,
    },
    radioRoundItem: {
        height: 56,
        "&:hover": {
            borderRadius: 1,
        },
    },
    radioRoundDeafult: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
        height: 24,
        padding: 16,
    },
    radioRoundLeft: {
        display: "flex",
        alignItems: "center",
        fontWeight: 400,
        fontSize: 16,
    },
    radioRoundRight: {
        display: "flex",
        alignItems: "center",
        fontWeight: 400,
        fontSize: 14,
        marginLeft: 10,
    },
    radioIconCountryIcon: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: 27,
        height: 18,
        marginLeft: 10,
    },
    radioRoundChoosed: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        backgroundColor: "rgba(116, 127, 141, 0.24)",
        width: "100%",
        height: 24,
        padding: 16,
    },
    radioIconRound: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: 24,
        height: 24,
        marginRight: 8,
        color: "rgb(255, 255, 255)",
        backgroundColor: "rgb(67, 181, 129)",
        borderRadius: 12,
    },
    language: {
        color: theme.app.SettingRoundRadioButtonView.language,
    },
    country: {
        color: theme.app.SettingRoundRadioButtonView.country,
    },
}); });
function SettingRoundRadioButtonViewDefault(props) {
    var language = props.language, country = props.country, icon = props.icon, onClick = props.onClick;
    var classes = useStyle();
    var handleLanguage = function (newoption) {
        onClick(newoption);
    };
    return (React.createElement("div", { className: classes.Wrap },
        React.createElement(MenuItem_1.default, { disableGutters: true, onClick: function () { return handleLanguage(language); }, className: classes.radioRoundItem },
            React.createElement("div", { className: classes.radioRoundDeafult },
                React.createElement("div", { className: classes.radioRoundLeft },
                    React.createElement("div", { className: classes.radioIcon },
                        React.createElement(Icon_1.default, { style: { fontSize: 28 } }, "radio_button_unchecked")),
                    React.createElement("span", { className: classes.language }, language)),
                React.createElement("div", { className: classes.radioRoundRight },
                    React.createElement("span", { className: classes.country }, country),
                    React.createElement("img", { className: classes.radioIconCountryIcon, src: icon }))))));
}
exports.SettingRoundRadioButtonViewDefault = SettingRoundRadioButtonViewDefault;
function SettingRoundRadioButtonViewChoosed(props) {
    var language = props.language, country = props.country, icon = props.icon, onClick = props.onClick;
    var classes = useStyle();
    var handleLanguage = function (newlanguage) {
        onClick(newlanguage);
    };
    return (React.createElement("div", { className: classes.Wrap },
        React.createElement(MenuItem_1.default, { disableGutters: true, onClick: function () { return handleLanguage(language); }, className: classes.radioRoundItem },
            React.createElement("div", { className: classes.radioRoundChoosed },
                React.createElement("div", { className: classes.radioRoundLeft },
                    React.createElement("div", { className: classes.radioIconRound },
                        React.createElement(Icon_1.default, { style: { fontSize: 17 } }, "check")),
                    React.createElement("span", { className: classes.language }, language)),
                React.createElement("div", { className: classes.radioRoundRight },
                    React.createElement("span", { className: classes.country }, country),
                    React.createElement("img", { className: classes.radioIconCountryIcon, src: icon }))))));
}
exports.SettingRoundRadioButtonViewChoosed = SettingRoundRadioButtonViewChoosed;
//# sourceMappingURL=SettingRoundRadioButtonView.js.map